<template>
    <div :class="detailsClass">
        <button type="button" :disabled="isProcessing" :class="ctaClass" @click="handleCheckAvailability()">
            <common-icon name="calendar" size="gigantic"></common-icon>

            <p>
                <em>{{ $t('elements.referrals.card.check_availability') }}</em>
            </p>

            <common-loader :isProcessing="isProcessing" color="#fff"></common-loader>
        </button>

        <direct-referral
            v-if="isDirectReferralModalOpen"
            ref="directReferral"
            :showAsInnerModal="showDirectReferralAsInnerModal"
            :user="userData"
            :insurancePlanId="Number($route.query.insurancePlanId) || insurancePlanId"
            :existingReferral="existingReferralObj"
            :activePracticeType="activePracticeType"
            @location-selected="toggleDirectReferralModal"
            @close="toggleDirectReferralModal"
        ></direct-referral>

        <common-modal
            v-if="isAncillaryLocationSelectorOpen"
            :showAsInnerModal="showDirectReferralAsInnerModal"
            width="large"
            height="medium"
            @close="toggleAncillaryLocationSelector"
        >
            <ancillary-location-selector
                :ancillaryPractice="ancillary"
                @location-selected="toggleAncillaryLocationSelector"
                @close="toggleAncillaryLocationSelector"
            ></ancillary-location-selector>
        </common-modal>
    </div>
</template>

<script>
    import DirectReferral from 'components/page-elements/referrals/DirectReferral'
    import AncillaryLocationSelector from 'components/page-elements/referrals/AncillaryLocationSelector'
    import PracticeTypeEnum from '@/enums/PracticeTypeEnum'

    export default {
        components: {
            DirectReferral,
            AncillaryLocationSelector,
        },

        props: {
            physician: { type: Object, required: false, default: () => {} },
            ancillary: { type: Object, required: false, default: () => {} },
            practiceId: { type: Number, required: true },
            locations: { type: Array, required: true, default: () => [] },
            insurancePlanId: { type: Number, required: false, default: null },
            existingReferral: { type: Object, required: false, default: null },
            showDirectReferralAsInnerModal: { type: Boolean, default: false },
        },

        data() {
            return {
                isDirectReferralModalOpen: false,
                isAncillaryLocationSelectorOpen: false,
                isProcessing: false,
                activePracticeType: null,
                PracticeTypeEnum: PracticeTypeEnum,
            }
        },

        computed: {
            detailsClass() {
                return {
                    'card-availability': true,
                }
            },

            ctaClass() {
                return {
                    'card-availability__cta': true,
                    'card-availability__cta--is-processing': this.isProcessing,
                }
            },
            existingReferralObj() {
                return this.existingReferral || this.$route.params.existingReferral || null
            },

            userData() {
                return this.physician.id ? this.physician : this.ancillary
            },
        },

        methods: {
            handleCheckAvailability() {
                if (!this.$auth.getActiveMember()) {
                    this.emitEvent({
                        name: 'go-to-registration',
                    })
                    return
                }
                if (this.$route.query.practiceType === PracticeTypeEnum.ANCILLARY && this.$route.name !== 'network.connections') {
                    if (this.locations.length === 1) {
                        const query = {
                            ...this.$route.query,
                            practiceLocationId: this.locations[0].id || 0,
                            practiceId: this.ancillary.id,
                            isMatchReferral: true,
                        }
                        this.$router.push({
                            name: `referrals.services.tests`,
                            query: query,
                            params: {
                                existingReferral: false,
                            },
                        })
                        this.emitEvent({ name: 'location-selected' })
                    } else {
                        this.toggleAncillaryLocationSelector()
                    }
                } else {
                    if (!!Number(this.$route.query.insurancePlanId) && this.locations.length === 1) {
                        this.checkAvailability(this.locations[0])
                    } else {
                        if (this.$route.name === 'network.connections') {
                            this.activePracticeType = this.$route.query.practiceType
                            this.toggleDirectReferralModal()
                            return
                        }
                        if (this._props.ancillary) {
                            this.activePracticeType = PracticeTypeEnum.ANCILLARY
                        }
                        this.toggleDirectReferralModal()
                    }
                }
            },

            checkAvailability({ id: practiceLocationId }) {
                this.isProcessing = true

                this.emitEvent({
                    name: 'checkAvailability',
                    payload: {
                        physicianId: this.$get(this.physician, 'id'),
                        practiceId: this.practiceId,
                        practiceLocationId,
                        target: this.physician,
                    },
                })
            },

            toggleDirectReferralModal() {
                this.isDirectReferralModalOpen = !this.isDirectReferralModalOpen
            },

            toggleAncillaryLocationSelector() {
                this.isAncillaryLocationSelectorOpen = !this.isAncillaryLocationSelectorOpen
            },
        },
    }
</script>
